import { title } from "framer-motion/client";

export const es = {
  translation: {
    nav: {
      title: 'Zen Life Acupuntura',
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      gallery: 'Galería',
      appointment: 'Cita',
      herbtea: 'Té Herbal',
      telemedicine: "Telemedicina",
      store: "Tienda",
    },
    home: {
      welcome: 'Bienvenido a Zen Life Acupuntura',
      "subtitle": "Tradición e innovación, sanación con dedicación",
      "description1": "Experimenta el poder curativo único de la acupuntura a través de la perfecta combinación de la medicina moderna y la medicina tradicional china.",
      "description2": "Llevamos con orgullo el conocimiento transmitido por tres generaciones, incorporando conceptos médicos modernos para ofrecer atención profesional y personalizada a cada paciente.",
      "description3": "Nuestro equipo de acupuntores no solo domina la acupuntura tradicional, ventosas, gua sha y fitoterapia china, sino que también ha desarrollado técnicas propias que han tratado con éxito problemas complejos como parálisis facial, hernia discal, ciática y dolor por compresión cervical.",
      "description4": "Aquí encontrarás la profundidad de la medicina tradicional china junto con la eficacia de los avances médicos modernos. ¡Permítenos ayudarte a recuperar tu salud y vitalidad!",
      subtitleinsurance: '¿Te preguntas si tu seguro cubre la acupuntura? ',
      insuranceprompt: 'Envía tu pregunta por mensaje de texto al 408-922-6848 o por correo electrónico a zenlifeacu@gmail.com. Por favor, incluye tu nombre, número de teléfono, fecha de nacimiento y fotos de ambas caras de tu tarjeta de seguro.',
      contactButton: 'Contáctenos',
      bookButton: 'Agenda una cita',
      promotions: 'Promociones y Anuncios',
      videoTitle: "Caja Sorpresa de Té Herbal Misterioso",
      videoDescription: "Todos los domingos, ofrecemos una bebida especial oculta de té herbal chino gratis, disponible solo para degustación el mismo día"
    },
    services: {
      title: 'Nuestros Servicios',
      acupuncture: {
        title: 'Acupuntura',
        description: 'Tratamiento para dolor de hombros, dolor de cabeza, ciática, alergias, reducción de arrugas, pérdida de peso, insomnio y más.'
      },
      electroacupuncture: {
        title: 'Electroacupuntura',
        description: 'Dolor crónico, Trastornos neurológicos, Recuperación de lesiones deportivas, Problemas emocionales, Trastornos digestivos, Problemas ginecológicos'
      },
      cupping: {
        title: 'Ventosas',
        description: 'Alivio del dolor, drenaje de humedad, tratamiento de ciática, desintoxicación y más.'
      },
      guaSha: {
        title: 'Gua Sha',
        description: 'Tratamiento para dolor menstrual, dolor lumbar, dolor de rodilla y mejora del sistema inmunológico.'
      },
      manualTherapy: {
        title: 'Terapia Manual',
        description: 'Técnicas terapéuticas manuales para aliviar el dolor y promover la curación.'
      },
      infraLight: {
        title: 'Terapia de Luz Infrarroja',
        description: 'Terapia de luz avanzada para mejorar la curación y aliviar el dolor.'
      },
      herbs: {
        title: 'Hierbas Chinas',
        description: 'Remedios herbales tradicionales personalizados según sus necesidades.'
      }
    },
    contact: {
      title: 'Contáctenos',
      direction: 'Ubicación',
      address: {
        title: 'Dirección',
        value: '8 N Abel St, Milpitas, CA 95035'
      },
      phone: {
        title: 'Teléfono',
        regularHours: 'Horario Regular: 408-922-6848',
        afterHours: 'Fuera de Horario: 408-465-4289'
      },
      email: {
        title: 'Correo',
        value: 'zenlifeacu@gmail.com'
      },
      payment: {
        title: 'Métodos de Pago',
        description: 'Aceptamos todos los seguros PPO principales, tarjetas de crédito, HSA, PayPal, Venmo'
      },
      findUs: 'Estamos ubicados en el corazón de Milpitas, fácilmente accesible desde I-880 y I-680.',
      specializedClaims: "Reclamaciones de Seguros Especializados",
      carAccidentClaims: "Aceptamos reclamaciones de seguros por accidentes automovilísticos y proporcionamos documentación completa de tratamiento para pacientes, compañías de seguros y representantes legales que manejan las reclamaciones.",
      workersCompClaims: "Procesamos reclamaciones de compensación laboral por lesiones en el lugar de trabajo, ayudando a los pacientes a recuperarse y volver al trabajo.",
      legalReferrals: "Damos la bienvenida a referencias de pacientes de bufetes de abogados especializados en lesiones personales y casos de compensación laboral."
    },
    // Add to existing es.js translation object
    footer: {
      title: 'Zen Life Acupuntura',
      address: '8 N Abel St\nMilpitas, CA 95035',
      contact: {
        title: 'Contacto',
        phone: 'Teléfono: 408-922-6848',
        email: 'Correo: zenlifeacu@gmail.com'
      },
      social: {
        title: 'Síguenos',
        wechat: 'WeChat: ZenLifeAcupuncture',
        rednote: 'RedNote: ZenLifeAcu'
      },
      copyright: 'Zen Life Acupuntura. Todos los derechos reservados.'
    },
    // ... existing code ...
    telemedicine: {
      title: "Servicios de Telemedicina",
      subtitle: "Consultas virtuales con nuestros acupunturistas experimentados desde la comodidad de su hogar",
      benefitsTitle: "Beneficios de Nuestro Servicio de Telemedicina",
      //payWithPayPal: "Pay with PayPal", // English
      payWithPayPal: "Pagar con PayPal", // Spanish
      // payWithPayPal: "PayPalで支払う", // Japanese
      // payWithPayPal: "Thanh toán bằng PayPal", // Vietnamese
      // payWithPayPal: "使用PayPal付款", // Chinese
      benefits: {
        benefit1: "Acceso conveniente a consultas profesionales de medicina china sin salir de casa",
        benefit2: "Prescripciones herbales personalizadas basadas en sus necesidades específicas de salud",
        benefit3: "Evaluación detallada de salud y planes de tratamiento personalizados",
        benefit4: "Seguimiento y ajustes a su tratamiento según sea necesario",
        benefit5: "Ahorre tiempo y evite desplazamientos mientras recibe atención especializada",
        benefit6: "Acceso a nuestro extenso conocimiento de medicina tradicional china y remedios herbales"
      },
      processTitle: "Cómo Funciona Nuestro Servicio de Telemedicina",
      process: {
        step1: {
          title: "1. Realice el Pago",
          description: "Utilice el botón de PayPal a continuación para pagar su consulta de telemedicina de 30 minutos."
        },
        step2: {
          title: "2. Programe su Cita",
          description: "Después del pago, programe su cita en línea usando su número de pedido. Podrá cargar su historial médico y cualquier resultado de laboratorio relevante."
        },
        step3: {
          title: "3. Consulta Virtual",
          description: "Reúnase con nuestro acupunturista licenciado a través de Zoom para discutir su condición médica. Proporcionaremos una evaluación integral, prescripción herbal si es necesario y consejos de salud."
        },
        step4: {
          title: "4. Pago de Medicina Herbal (si es necesario)",
          description: "Si se recomienda medicina herbal, le enviaremos una factura por las hierbas y los costos de envío. El pago se puede realizar en línea."
        },
        step5: {
          title: "5. Reciba Sus Hierbas",
          description: "Prepararemos y enviaremos su fórmula herbal personalizada directamente a su hogar."
        }
      },
      paymentTitle: "Reserve su Consulta de Telemedicina",
      consultationFee: "Consulta de 30 Minutos: $50",
      afterPayment: "Después del pago, recibirá un correo electrónico de confirmación con su número de pedido. Use este número para programar su cita.",
      scheduleButton: "Programar Cita",
      herbsTitle: "Sobre Nuestras Medicinas Herbales",
      herbsDescription: "Nuestras prescripciones herbales están personalizadas según sus necesidades específicas de salud. Utilizamos solo hierbas chinas auténticas de alta calidad que son probadas por su pureza y potencia.",
      shippingInfo: "Los costos de medicina herbal y las tarifas de envío varían según la prescripción y su ubicación. Ofrecemos varios métodos de envío para satisfacer sus necesidades y presupuesto."
    },
    store: {
      title: "Tienda en Línea Zen Life",
      subtitle: "Productos de Medicina Tradicional China",
      description: "Explora nuestra selección de productos de medicina tradicional china de alta calidad. Envíos a todo el país.",
      buyNow: "Comprar Ahora",
      products: [
        {
          name: "Crema Hidratante Anti-Picazón 100% Natural",
          price: "$39.99",
          description: "Alivia la picazón y la piel seca y escamosa causada por eccema o dermatitis atópica. Solo para uso externo.",
          image: "/images/products/product1.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/USDMG75T3T7CW"
        },
        {
          name: "Infusiones de Hierbas para Diferentes Condiciones de Salud",
          price: "$80",
          description: "Mezclas de hierbas artesanales específicamente formuladas para diversas condiciones de salud. Cada paquete premium proporciona un suministro para todo el día de té terapéutico, rindiendo hasta 1 galón de agua para máximo beneficio. Nuestras hierbas cuidadosamente seleccionadas brindan apoyo natural para el bienestar durante todo el día.",
          image: "/images/products/product2.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
        }
        // More products can be added here later
      ]
    },
    // ... existing code ...
    herbtea: {
      title: "🌿 Té Herbal Chino · Especialmente Elaborado para Ingenieros del Área de la Bahía 🌿",
      subtitle: "☕ Bienestar Incluso en Tiempos Ocupados — ¡Cuidamos de tu Salud Física y Mental!",
      description: "Basado en hierbas chinas naturales puras y la teoría de la medicina tradicional china, formulamos cuidadosamente varios tés de bienestar adecuados para ingenieros del Área de la Bahía. Según las diferentes constituciones corporales y necesidades, puedes elegir flexiblemente el curso de terapia de té que te convenga:",
      benefits: [
        "✔ Dosis proporcionada científicamente, sin necesidad de preparar medicina",
        "✔ Bolsitas de té para preparación instantánea, simple y conveniente",
        "✔ Un curso dura tres semanas, solo tres tazas por semana",
        "✔ ¡Bienvenido a nuestra tienda para una degustación gratuita!"
      ],
      benefits1: "efectos",
      ingredients: "Ingredientes",
      customService: {
        title: "🧑‍⚕️ Servicio Personalizado · Adaptado a Tu Cuerpo",
        description: "Proporcionamos análisis de constitución de MTC uno a uno y servicios de té personalizados para crear un plan de bienestar personalizado para ti:",
        options: [
          {
            name: "Té Personalizado para Mantenimiento de la Salud",
            details: "Consulta + Un curso de té de bienestar (en forma de bolsita de té)",
            price: "Solo $80"
          },
          {
            name: "Servicio Terapéutico de Medicina China",
            details: "Consulta + Un curso de decocción concentrada de medicina china (para tratamiento de síntomas específicos)",
            price: "$200"
          }
        ]
      },
      popularTeas: {
        title: "🍵 Cinco Tés de Bienestar Populares Recomendados",
        teas: [
          {
            id: 1,
            name: "Té de Madreselva",
            ingredients: "Astrágalo, Madreselva, Flor de Magnolia, Crisantemo",
            benefits: "Mejora la inmunidad, alivia la sensibilidad nasal y las alergias al polen"
          },
          {
            id: 2,
            name: "Bebida Calmante Nutritiva para el Corazón",
            ingredients: "Salvia, Bulbo de Lirio, Semilla de Azufaifo Ácido, Acoro Calamus",
            benefits: "Mejora la calidad del sueño, calma la mente"
          },
          {
            id: 3,
            name: "Bebida de Ginseng Poria Atractylodes",
            ingredients: "Cáscara de Mandarina, Atractylodes, Poria, Semilla de Coix, Jinqiancao, Mano de Buda",
            benefits: "Fortalece el bazo, elimina la humedad, regula el sistema digestivo"
          },
          {
            id: 4,
            name: "Té Calmante y Potenciador de la Inteligencia",
            ingredients: "Alpinia Oxyphylla, Bayas de Goji, Salvia, Acoro Calamus",
            benefits: "Mejora la circulación cerebral, refresca la mente"
          },
          {
            id: 5,
            name: "Té Nutritivo de Belleza",
            ingredients: "Astrágalo, Salvia, Angélica, Bayas de Goji, Flor de Rosa",
            benefits: "Repone el qi y la sangre, embellece la piel"
          }
        ]
      },
      pricing: {
        title: "💰 Beneficios de Precio · Opciones Flexibles",
        options: [
          "Paquete de prueba de tres tazas: $15",
          "Paquete básico de seis tazas: $26",
          "Paquete de curso de nueve tazas: $40",
          "Personalizado para mantenimiento de la salud (consulta + té): $80",
          "Medicina china concentrada terapéutica (consulta + decocción): $200"
        ],
        promotion: "🎁 ¡Visita nuestra tienda para una degustación gratuita y comienza tu viaje de bienestar personalizado!"
      }
    }
  },
  electroAcupunture: {
    "header": "Electroacupuntura y sus Beneficios",
    "section1_title": "Concepto Básico de la Electroacupuntura",
    "section1_text": "La electroacupuntura es un método de tratamiento que combina la acupuntura tradicional con la electroterapia moderna. Después de insertar agujas en puntos específicos del cuerpo, se aplica una corriente eléctrica suave para estimularlos. Se utiliza ampliamente para el manejo del dolor, trastornos neurológicos, problemas musculares y articulares, y para mejorar la salud general.",

    "section2_title": "Beneficios Principales de la Electroacupuntura",
    "benefit1": "Alivio del dolor: La electroacupuntura ayuda a aliviar el dolor crónico y agudo mediante la regulación de las señales de dolor en el sistema nervioso, siendo eficaz en el tratamiento de condiciones como artritis, dolores de cabeza, dolores en los hombros, etc.",
    "benefit2": "Mejora de la circulación sanguínea: La estimulación eléctrica promueve la circulación sanguínea local, ayudando a suministrar oxígeno y nutrientes a los tejidos, promoviendo el metabolismo y reduciendo la inflamación.",
    "benefit3": "Regulación del sistema nervioso: La electroacupuntura estimula el sistema nervioso autónomo, ayudando a aliviar la ansiedad, el insomnio y potenciando la respuesta inmune.",
    "benefit4": "Alivio de espasmos musculares y relajación: La corriente eléctrica relaja eficazmente los músculos tensos, mejorando su flexibilidad y aliviando espasmos y rigidez.",
    "benefit5": "Promoción de la reparación y recuperación de tejidos: La electroacupuntura acelera la reparación de los tejidos lesionados, favoreciendo la regeneración celular y utilizada comúnmente en la rehabilitación de lesiones deportivas.",
    "benefit6": "Fortalecimiento de la inmunidad: Regula la respuesta inmune, mejorando la resistencia del cuerpo a infecciones y es beneficiosa para tratar enfermedades crónicas y autoinmunes.",

    "section3_title": "Indicaciones para la Electroacupuntura",
    "indication1": "Dolor crónico (como artritis, dolor de espalda, dolor de cuello)",
    "indication2": "Trastornos neurológicos (como rehabilitación post-ACV, parálisis facial)",
    "indication3": "Recuperación de lesiones deportivas (como esguinces musculares, daño a ligamentos)",
    "indication4": "Problemas emocionales (como insomnio, ansiedad)",
    "indication5": "Problemas digestivos (como estreñimiento, diarrea)",
    "indication6": "Problemas ginecológicos (como menstruación irregular, dismenorrea)",

    "section4_title": "Precauciones para la Electroacupuntura",
    "precaution1": "Consulta antes del tratamiento: La electroacupuntura no es adecuada para todos, especialmente para personas con enfermedades cardíacas, problemas cutáneos o mujeres embarazadas. Consulte a un acupunturista profesional antes de usarla.",
    "precaution2": "Durante el tratamiento, algunas personas pueden sentir una leve sensación de hormigueo o corriente eléctrica. Si experimenta incomodidad, informe al médico para ajustar la intensidad.",
    "precaution3": "Evite el uso excesivo: Aunque la electroacupuntura es eficaz, el uso frecuente o de alta intensidad puede causar efectos negativos en la piel y los tejidos."
  }
};